<template>
	<!-- 联系客服 -->
	<div class="ql-editor box-shadow">
		<div style="padding: 30px 0;width: 45vw;" v-html="content"></div>
	</div>
</template>

<script>
	import {
		getAgreement
	} from '@/api/personal/api.js';
	export default {
		data() {
			return {
				content: ''
			}

		},
		mounted() {
			this.getInit();
		},
		methods: {
			getInit() {
				getAgreement({
					type: 4
				}).then(res => {
					this.content = res.data.content;
					this.content = this.content.replace(/<img/g,
						'<img mode="widthFix" style="width: 98%"');
				})
			}
		}
	}
</script>


<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}
	
	.ql-editor{
		line-height: 28px;
		/* font-size: 12px; */
	}

	.pad-16 {
		padding: 16px;
	}
</style>